import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

/**
 * Brief-builder toggle switch. Presentational; parent owns state via [checked]/(checkedChange).
 */
@Component({
  selector: 'bb-switch',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <button
      type="button"
      role="switch"
      [attr.aria-checked]="checked()"
      [attr.aria-label]="ariaLabel()"
      [disabled]="disabled()"
      (click)="toggle()"
      class="relative inline-flex h-6 w-11 flex-shrink-0 items-center rounded-full transition-colors duration-200 focus-visible:outline-2 focus-visible:outline-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
      [class]="checked() ? 'bg-brand-studio' : 'bg-muted'">
      <span
        class="inline-block size-5 transform rounded-full bg-white shadow-sm transition-transform duration-200"
        [class]="checked() ? 'translate-x-5' : 'translate-x-0.5'"></span>
    </button>
  `,
})
export class BbSwitch {
  readonly checked = input<boolean>(false);
  readonly disabled = input<boolean>(false);
  readonly ariaLabel = input<string>('');
  readonly checkedChange = output<boolean>();

  toggle(): void {
    if (this.disabled()) {
      return;
    }
    this.checkedChange.emit(!this.checked());
  }
}
